module.exports = __webpack_public_path__ + "static/media/buildingConstruction23.e1f2e065.jpg";